"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useEntityList = useEntityList;
const hooks_1 = require("../../../../../../ui/hooks");
const mapEntityListRequest_1 = require("../utils/mapEntityListRequest");
function useEntityList(props, request) {
    const response = (0, hooks_1.useStorageList)(props.entity, (0, mapEntityListRequest_1.mapEntityListRequest)(props, request));
    return {
        ...response,
        data: response.data
            ? {
                rows: response.data.rows,
                filteredRowCount: response.data.total,
            }
            : undefined,
        reload: response.mutate,
    };
}
